import { metricKeys } from '@pulse/metrics';
import metricsStore from '@src/globalStore/metricsStore';

// metric columns for dimension tables when metric filter is applied
export const METRIC_SPECIFIC_DIMENSION_MAPPING = {
  // [metricKeys.VideoStartFailures]: [metricKeys.VideoStartFailures],
  //  [metricKeys.VideoStartFailuresTech]: [metricKeys.VideoStartFailuresTech],
  //  [metricKeys.VideoStartFailuresBusiness]: [metricKeys.VideoStartFailuresBusiness],
  //  [metricKeys.ExitBeforeVideoStarts]: [metricKeys.ExitBeforeVideoStarts],
  //  [metricKeys.VideoPlaybackFailures]: [metricKeys.VideoPlaybackFailures],
  //  [metricKeys.VideoPlaybackFailuresTech]: [metricKeys.VideoPlaybackFailuresTech],
  //  [metricKeys.VideoPlaybackFailuresBusiness]: [metricKeys.VideoPlaybackFailuresBusiness],
  //  [metricKeys.ExitsDuringPreRoll]: [metricKeys.ExitsDuringPreRoll],
  [metricKeys.VideoStartTime]: [metricKeys.Plays, metricKeys.UniqueDevicesWithAttempts],
  [metricKeys.LifeJoinedAvgBitrate]: [metricKeys.EndedPlays, metricKeys.UniqueDevices],
  [metricKeys.EndingBitrate]: [metricKeys.EndedPlays, metricKeys.UniqueDevices],
  // For App
  [metricKeys.AppAvgScreenLoadTime]: [metricKeys.AppScreenLoads, metricKeys.AppUniqueDevices],
  [metricKeys.AppStartupTime]: [metricKeys.AppStartupCount, metricKeys.AppUniqueDevices],
  [metricKeys.AverageMinutesPerPage]: [metricKeys.AppUniqueDevices],
  [metricKeys.TimeToFirstAttempt]: [metricKeys.AppSessions, metricKeys.AppUniqueDevices],
  [metricKeys.AverageRequestDuration]: [
    metricKeys.AverageRequestCount,
    metricKeys.AppUniqueDevices,
  ],
};

// TODO: clean up when new data model GA
export const METRIC_SPECIFIC_DIMENSION_MAPPING_FOR_NEW_DATA_MODEL = {
  ...METRIC_SPECIFIC_DIMENSION_MAPPING,
  [metricKeys.AppStartupTime]: [metricKeys.AppStartupCount],
  [metricKeys.TimeToFirstAttempt]: [metricKeys.AppSessionCountForTTFA],
};

export const getMetricSpecificDimensionMapping = (metric: string) => {
  if (!metric) {
    return undefined;
  }
  return METRIC_SPECIFIC_DIMENSION_MAPPING_FOR_NEW_DATA_MODEL[metric];
};

// metric columns for dimension tables when metric filter is applied
export const getMetricDimensionMapping = (category: string) => {
  const { metricsCategoryKeys } = metricsStore.getState();
  const metricConfig = {
    [metricsCategoryKeys.VIDEO_STARTUP]: [
      metricKeys.Attempts,
      metricKeys.UniqueDevicesWithAttempts,
    ],
    [metricsCategoryKeys.VIDEO_PLAYBACK]: [metricKeys.EndedPlays, metricKeys.UniqueDevices],
    [metricsCategoryKeys.VIDEO_ENGAGEMENT]: [metricKeys.EndedPlays, metricKeys.UniqueDevices],
    [metricsCategoryKeys.SP]: [metricKeys.Attempts],
  };
  return metricConfig[category];
};

//Global sort by values for dimension tables when metric filter is applied
export const METRIC_DIMENSION_GLOBAL_SORT_BY_MAPPING = {
  [metricKeys.RebufferingRatio]: metricKeys.EndedPlays,
  [metricKeys.ConnectionInducedRebufferingRatio]: metricKeys.EndedPlays,
  [metricKeys.Bitrate]: metricKeys.EndedPlays,
  [metricKeys.Framerate]: metricKeys.EndedPlays,
  [metricKeys.VideoRestartTime]: metricKeys.EndedPlays,
  [metricKeys.Minutes]: metricKeys.EndedPlays,
  [metricKeys.PercentageComplete]: metricKeys.EndedPlays,
  [metricKeys.VideoStartTime]: metricKeys.Plays,
  [metricKeys.NonZeroCIRREndedPlays]: metricKeys.EndedPlays,
  [metricKeys.PausedRatio]: metricKeys.EndedPlays,
  [metricKeys.PausedTime]: metricKeys.EndedPlays,
  [metricKeys.LifeAvgNumBitrateSwitches]: metricKeys.EndedPlays,
  [metricKeys.LifeJoinedAvgBitrate]: metricKeys.EndedPlays,
  [metricKeys.EndingBitrate]: metricKeys.EndedPlays,
  [metricKeys.VideoStartFailures]: metricKeys.Attempts,
  [metricKeys.VideoStartFailuresTech]: metricKeys.Attempts,
  [metricKeys.VideoStartFailuresBusiness]: metricKeys.Attempts,
  [metricKeys.ExitBeforeVideoStarts]: metricKeys.Attempts,
  [metricKeys.VideoPlaybackFailures]: metricKeys.EndedPlays,
  [metricKeys.VideoPlaybackFailuresTech]: metricKeys.EndedPlays,
  [metricKeys.VideoPlaybackFailuresBusiness]: metricKeys.EndedPlays,
  [metricKeys.ExitsDuringPreRoll]: metricKeys.Attempts,
  [metricKeys.ExitDueToCIR]: metricKeys.EndedPlays,
  [metricKeys.BadSession]: metricKeys.SpiStreams,
  [metricKeys.LifeDropFrameRatio]: metricKeys.EndedPlays,
};
